import { AI_STORAGE_KEYS } from '../constants/index.ts';

/**
 * Tạo khóa localStorage phân vùng theo người dùng để lưu ID cuộc trò chuyện.
 * Đảm bảo các tài khoản khác nhau trên cùng thiết bị không bị lẫn lộn lịch sử chat.
 *
 * @param userId - ID người dùng đã xác thực (từ authUser.id)
 * @returns Khóa lưu trữ cục bộ tương ứng
 */
export function getChatIdStorageKey(userId: string | undefined): string {
  return userId ? `${AI_STORAGE_KEYS.CHAT_ID_PREFIX}-${userId}` : AI_STORAGE_KEYS.CHAT_ID_GUEST;
}

/**
 * Sinh ID duy nhất cho phiên làm việc hiện tại.
 * - Người dùng đã đăng nhập: sử dụng user.id
 * - Khách vãng lai: sinh chuỗi UUID ngẫu nhiên theo phiên
 *
 * @param user - Đối tượng người dùng xác thực hoặc undefined đối với khách
 * @returns Định danh duy nhất cho phiên
 */
export function getSessionId(user: { id?: string | number | null } | null | undefined): string {
  if (user?.id) {
    return String(user.id);
  }
  // randomUUID needs Chrome 92 and a secure context
  const id = typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
  return `guest-${id}`;
}
